import DivisionDateContainer from '../../../containers/division/divisionDate/divisionDateContainer';

export default function DivisionDate() {
  return (
    <DivisionDateContainer />
  );
}
